import React, { useContext } from "react";
import Card from "../../../components/card/card";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";

const EmailVerified = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);

  return (
    <Card
      title={"Your email has been verified successfully"}
      description={"Please press continue to start the appointment process"}
      btnTitle={"Continue"}
      onHandleClick={() =>
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep + 1,
        })
      }
      progress={activeStep * 5}
    />
  );
};

export default EmailVerified;
